// extracted by mini-css-extract-plugin
export default {"newTabLinkIcon":"accessibilityReportContent_newTabLinkIcon__-1XW0","subtitle":"accessibilityReportContent_subtitle__8W5vQ"};